import type { RequestTypeEnum } from "@nlc/shared-types";

import { createFileRoute } from "@tanstack/react-router";

import { MockedEditRequestPage } from "@/features/templates/MockedEditRequestPage";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/requests/template")({
  component: function RequestTemplateRoute() {
    usePageTitle("Request Template");

    return (
      <main className="h-full w-full bg-bg-tertiary sm:p-4 overflow-y-auto sm:overflow-hidden scrollbar-none">
        <MockedEditRequestPage />
      </main>
    );
  },
  validateSearch: (search: Record<string, unknown>) => ({
    "request-type": search["request-type"] as
      | RequestTypeEnum.GRAPHIC
      | RequestTypeEnum.VIDEO,
  }),
});
